// login
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOG_OUT = "LOG_OUT";
export const LOG_IN_FAILURE = "LOG_IN_FAILURE";
export const AUTHENTICATE = "AUTHENTICATE";
export const SET_USER = "SET_USER";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const SET_PERMISSIONS = "SET_PERMISSIONS";

// manage user
export const AGENCY_PROFILE = 'ADMIN_PROFILE';
export const SAVE_AGENCY = 'SAVE_AGENCY';
export const SAVE_LOCATION = 'SAVE_LOCATION';
export const USER_LIST = 'USER_LIST';
export const USER_DETAIL = 'USER_DETAIL';
export const SELECTED_LOCATION = 'SELECTED_LOCATION';
export const SET_LOCATION = "SET_LOCATION";
export const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS";
export const ADD_USER_PERMISSIONS = "ADD_USER_PERMISSIONS";
export const UPDATE_USER_PERMISSIONS = "UPDATE_USER_PERMISSIONS";
export const DELETE_USER_PERMISSIONS = "DELETE_USER_PERMISSIONS";
export const GET_FUNCTION_LIST = "GET_FUNCTION_LIST";
export const GET_ADMIN_SUPPORT_LIST = "GET_ADMIN_SUPPORT_LIST";
export const GET_USER_MODULE_PERMISSIONS = "GET_USER_MODULE_PERMISSIONS";
export const UPDATE_USER_MODULE_PERMISSIONS = "UPDATE_USER_MODULE_PERMISSIONS";
export const GET_USER_WORK_SETTING = "GET_USER_WORK_SETTING" ;
export const UPDATE_USER_WORK_SETTING = "UPDATE_USER_WORK_SETTING";
export const GET_USER_LIST_EXCEPT_AGENCY_MONITOR = "GET_USER_LIST_EXCEPT_AGENCY_MONITOR";

// Agency Revenue
export const AGENCY_REVENUE = "AGENCY_REVENUE";
export const PL_LIST = "PL_LIST";
export const PI_CHART = "PI_CHART";
export const DEFAULT_AGENCY_PROFILE = "DEFAULT_AGENCY_PROFILE";
export const REVENUE_PROFILE = "REVENUE_PROFILE";
export const REVENUE_GOAL = "REVENUE_GOAL";
export const OVERRIDE_REVENUE_GOAL = "OVERRIDE_REVENUE_GOAL";
export const LINE_GRAPH = "LINE_GRAPH";

// PL Worksheet
export const PL_CATEGORY = "PL_CATEGORY";
export const PL_WORKSHEET = "PL_WORKSHEET";
export const OPERATIVE_ITEM = "OPERATIVE_ITEM";
export const PAYROLL_ITEM = "PAYROLL_ITEM";
export const CAPITAL_ITEM = "CAPITAL_ITEM";
export const MARKETING_ITEM = "MARKETING_ITEM";
export const PLANNED_ITEM = "PLANNED_ITEM";

// Job Description
export const AGENCY_JOB_TITLE = "AGENCY_JOB_TITLE";
export const JOB_DESCRIPTION = "JOB_DESCRIPTION";

// KPI
export const ALL_KPI_LIST = "ALL_KPI_LIST";
export const ALL_KPI_CATEGORY = "ALL_KPI_CATEGORY";
export const KPI_HEADING_LIST = "KPI_HEADING_LIST";
export const KPI_HEADING_ITEM_LIST = "KPI_HEADING_ITEM_LIST";
export const KPI_DESTINATION_CATEGORY = "KPI_DESTINATION_CATEGORY";

// Compensation Profile
export const COMPENSATION_LIST = "COMPENSATION_LIST";
export const STAFF_LIST = "STAFF_LIST";
export const PERFORMANCE_LIST = "PERFORMANCE_LIST";
export const PERFORMANCE_STATEMENT = "PERFORMANCE_STATEMENT";
export const COMPENSATION = "COMPENSATION";
export const COMPENSATION_KPI_LIST = "COMPENSATION_KPI_LIST";
export const GET_CURRENT_COMP_PROFILE = "GET_CURRENT_COMP_PROFILE";

// Daily Attendance
export const TIMESHEET = "TIMESHEET";
export const USER_TIMESHEET = "USER_TIMESHEET";
export const CLOCK_OUT_REASONS = "CLOCK_OUT_REASONS";

// Staff Dashboard
export const STAFF_KPI = "STAFF_KPI";
export const CLOCK_IN_STATUS = "CLOCK_IN_STATUS";
export const CORRECTION_REQUEST = "CORRECTION_REQUEST";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const STAFF_TRAINING_VIDEOS = "STAFF_TRAINING_VIDEOS";

// Staff data
export const STAFF_LIST_CORRECTION = "STAFF_LIST_CORRECTION";
export const STAFF_DATA_KPI = "STAFF_DATA_KPI";
export const KPI_HEADINGS = "KPI_HEADINGS";
export const STAFF_CORRECTION_REQUEST = "STAFF_CORRECTION_REQUEST";
export const ALL_CORRECTION_DATA = "ALL_CORRECTION_DATA";
export const MESSAGE_LIST = "MESSAGE_LIST";
export const SET_ACTIVE_DATA = "SET_ACTIVE_DATA";
export const SET_DELETED_DATA = "SET_DELETED_DATA";

// Peer Evaluation
export const PEER_EVALUATION_USER_LIST = "PEER_EVALUATION_USER_LIST";
export const PEER_EVALUATION_QUESTIONAIRE_LIST = "PEER_EVALUATION_QUESTIONAIRE_LIST";

// Organic Growth Wizard
export const LOB_LIST = "LOB_LIST";
export const LOB_UPDATE = "LOB_UPDATE";
export const LOB_DELETE = "LOB_DELETE";
export const DEPARTMENT_SELECT = "DEPARTMENT_SELECT";
export const PL_PROFILE_SELECT = "PL_PROFILE_SELECT";


// Commission Report
export const COMPENSATION_SETTING = "COMPENSATION_SETTING";
export const COMP_PERIOD_BATCH = "COMP_PERIOD_BATCH";
export const GET_COMMISSION_REPORT = "GET_COMMISSION_REPORT";
export const GET_COMP_AGREEMENT = "GET_COMP_AGREEMENT";
export const GET_PERFORMANCE_REPORT = "GET_PERFORMANCE_REPORT";
export const GET_KPI_EXPLANATION_REPORT = "GET_KPI_EXPLANATION_REPORT";
export const GET_KPI_EXPLANATION_BATCH_REPORT = "GET_KPI_EXPLANATION_BATCH_REPORT";
export const GET_ACTIVITY_REPORT = "GET_ACTIVITY_REPORT";
export const GET_ACTIVITY_DATA_LIST = "GET_ACTIVITY_DATA_LIST";

//Compliance Audit
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_CATEGORY_ITEM_SUCCESS = "GET_CATEGORY_ITEM_SUCCESS";
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS";
export const AUDIT_CATEGORY_LIST = "AUDIT_CATEGORY_LIST";
export const GET_AUDIT_ITEM_LIST = "AUDIT_ITEM_LIST";
export const ADD_AUDIT_ITEM = "ADD_AUDIT_ITEM";
export const UPDATE_AUDIT_ITEM = "UPDATE_AUDIT_ITEM";
export const DELETE_AUDIT_ITEM = "DELETE_AUDIT_ITEM";
export const GET_AUDIT_STATUS = "GET_AUDIT_STATUS";
export const UPDATE_AUDIT_STATUS = "UPDATE_AUDIT_STATUS";

//Save State
export const SAVE_STATE = "SAVE_STATE";
export const REMOVE_STATE = 'REMOVE_STATE';

// Installation wizard
export const IW_MODULES = "IW_MODULES";
export const IW_VIDEOS = "IW_VIDEOS";
export const IW_STATUS = "IW_STATUS";

// KPI Planning
export const KPI_PLANNING_CATEGORIES = 'KPI_PLANNING_CATEGORIES'; 
export const DESTINATION_ITEMS = 'DESTINATION_ITEMS'; 
export const HABITS_ITEMS = 'HABITS_ITEMS';
export const KPI_PLANNING_KPI_LIST = 'KPI_PLANNING_KPI_LIST';
export const JOB_KPIS = 'JOB_KPIS';
export const ALL_JOB_KPIS = 'ALL_JOB_KPIS';
export const JOB_LIST = 'JOB_LIST';

//Agency Monitor Admin
export const MONITOR_HEADER_SETTINGS = 'MONITOR_HEADER_SETTINGS';
export const ALL_USERS = 'ALL_USERS';
export const ALL_PAGES = 'ALL_PAGES';
export const ALL_PAGE_POSITION = 'ALL_PAGE_POSITION';
export const ALL_KPIS = 'ALL_KPIS';
export const ADD_TO_PAGE_POSITION = 'ADD_TO_PAGE_POSITION';
export const DELETE_PAGE_POSITION = 'DELETE_PAGE_POSITION';
export const GET_PAGE_DATA = 'GET_PAGE_DATA';
export const AGENCY_PL_PROFILE = 'AGENCY_PL_PROFILE';
export const FIRST_TIME_RELOAD = 'FIRST_TIME_RELOAD';

//Agency Monitor Pages
export const SET_INDIVIDUAL_PAGE_DATA = 'SET_INDIVIDUAL_PAGE_DATA';

//update version
export const UPDATE_APP_VERSION = 'UPDATE_APP_VERSION';

// Knowledge Base
export const KB_CATEGORY_LIST = 'KB_CATEGORY_LIST';
export const KB_ITEM_LIST = 'KB_ITEM_LIST'; 
export const KB_FAQ_LIST = 'KB_FAQ_LIST';
export const KB_IW_ITEM_LIST = 'KB_IW_ITEM_LIST';

// PTO
export const PTO_SETTING = 'PTO_SETTING';
export const SICK_LEAVE_SETTING = 'SICK_LEAVE_SETTING';
export const PTO_TYPE_GET_LIST = 'PTO_TYPE_GET_LIST';
export const PTO_TYPE_CREATE = 'PTO_TYPE_CREATE';
export const PTO_TYPE_UPDATE = 'PTO_TYPE_UPDATE';
export const PTO_TYPE_DELETE = 'PTO_TYPE_DELETE';
export const PTO_REASON_GET_LIST = 'PTO_REASON_GET_LIST';
export const PTO_REASON_CREATE = 'PTO_REASON_CREATE';
export const PTO_REASON_UPDATE = 'PTO_REASON_UPDATE';
export const PTO_REASON_DELETE = 'PTO_REASON_DELETE';
export const HOLIDAY_CREATE = "HOLIDAY_CREATE";
export const HOLIDAY_UPDATE = "HOLIDAY_UPDATE";
export const HOLIDAY_DELETE = "HOLIDAY_DELETE";
export const HOLIDAY_GET_LIST = "HOLIDAY_GET_LIST";
export const ASSIGNED_HOLIDAY_GET_LIST = "ASSIGNED_HOLIDAY_GET_LIST";
export const HOLIDAY_CREATE_ASSIGNMENT = "HOLIDAY_CREATE_ASSIGNMENT"; 
export const HOLIDAY_UPDATE_ASSIGNMENT = "HOLIDAY_UPDATE_ASSIGNMENT"
export const TIMEOFF_REQUEST_LIST = "TIMEOFF_REQUEST_LIST";
export const CREATE_TIMEOFF_REQUEST = "CREATE_TO_REQUEST";
export const MODIFY_TIMEOFF_REQUEST = "MODIFY_TIMEOFF_REQUEST";
export const DELETE_TIMEOFF_REQUEST = "DELETE_TIMEOFF_REQUEST";
export const GET_PENDING_REQUESTS = "GET_PENDING_REQUESTS";
export const GET_PENDING_REQUEST_DATA = "GET_PENDING_REQUEST_DATA";
export const UPDATE_PENDING_REQUESTS = "UPDATE_PENDING_REQUESTS";
export const USER_PTO_INFO_LIST = "USER_PTO_INFO_LIST";
export const STAFF_PTO_INFO = "STAFF_PTO_INFO";
export const STAFF_SICK_LEAVE_INFO = "STAFF_SICK_LEAVE_INFO";
export const LEAVE_LIST = "LEAVE_LIST";
export const USER_REQUEST_LIST = "USER_REQUEST_LIST";
export const STAFF_ALLOWED_LIST = "STAFF_ALLOWED_LIST";
export const UPDATE_STAFF_ALLOWED_LIST = "UPDATE_STAFF_ALLOWED_LIST";
export const GET_BLACKOUT_DAY_LIST = "GET_BLACKOUT_DAY_LIST";
export const POST_BLACKOUT_DAY = "POST_BLACKOUT_DAY";
export const UPDATE_BLACKOUT_DAY = "UPDATE_BLACKOUT_DAY";
export const DELETE_BLACKOUT_DAY = "DELETE_BLACKOUT_DAY";
export const BIRTHDAY_LIST = "BIRTHDAY_LIST";

// Producer Compensation
export const PRODUCER_USERS = "PRODUCER_USERS";
export const PRODUCER_COMP_PERIODS = "PRODUCER_COMP_PERIODS";
export const GET_PRODUCER_NUMBER = "GET_PRODUCER_NUMBER";
export const UPDATE_PRODUCER_NUMBER = "UPDATE_PRODUCER_NUMBER";
export const GET_PRODUCER_REPORT = "GET_PRODUCER_REPORT";
export const GET_PRODUCER_LOB_LIST = "GET_PRODUCER_LOB_LIST";
export const CREATE_PRODUCER_LOB = "CREATE_PRODUCER_LOB";
export const UPDATE_PRODUCER_LOB = "UPDATE_PRODUCER_LOB";
export const DELETE_PRODUCER_LOB = "DELETE_PRODUCER_LOB";
export const GET_PACKAGE_CATEGORY_LIST = "GET_PACKAGE_CATEGORY_LIST";
export const CREATE_PACKAGE_CATEGORY = "CREATE_PACKAGE_CATEGORY";
export const UPDATE_PACKAGE_CATEGORY = "UPDATE_PACKAGE_CATEGORY";
export const DELETE_PACKAGE_CATEGORY = "DELETE_PACKAGE_CATEGORY";
export const GET_PACKAGE_NAME_LIST = "GET_PACKAGE_NAME_LIST";
export const CREATE_PACKAGE_NAME = "CREATE_PACKAGE_NAME";
export const UPDATE_PACKAGE_NAME = "UPDATE_PACKAGE_NAME";
export const DELETE_PACKAGE_NAME = "DELETE_PACKAGE_NAME";
export const GET_PACKAGE_FULL_LIST = "GET_PACKAGE_FULL_LIST";
export const GET_PACKAGES = "GET_PACKAGES";
export const CREATE_PACKAGE = "CREATE_PACKAGE";
export const UPDATE_PACKAGE = "UPDATE_PACKAGE";
export const DELETE_PACKAGE = "DELETE_PACKAGE";
export const GET_CONDITIONS = "GET_CONDITIONS";
export const CREATE_CONDITION = "CREATE_CONDITION";
export const UPDATE_CONDITION = "UPDATE_CONDITION";
export const DELETE_CONDITION = "DELETE_CONDITION";
export const GET_PRODUCER_SETTING = "GET_PRODUCER_SETTING";
export const UPADTE_PRODUCER_SETTING = "UPADTE_PRODUCER_SETTING";
export const GET_ASSIGNED_PACKAGES = "GET_ASSIGNED_PACKAGES";
export const ASSIGN_PACKAGE = "ASSIGN_PACKAGE";
export const UPDATE_ASSIGNED_PACKAGE = "UPDATE_ASSIGNED_PACKAGE";
export const DELETE_ASSIGNED_PACKAGE = "DELETE_ASSIGNED_PACKAGE";
export const GET_PRODUCER_KPI = "GET_PRODUCER_KPI";
export const PRODUCER_COMPENSATION = "PRODUCER_COMPENSATION";



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js